import { P1 } from '@zooplus/ui-components';
import React from 'react';
import styles from './ExamplesCard.module.scss';
import { InfoForExample } from '../../../model/product';
import { ArticlesList } from '../article-list';
import { Trans } from 'react-i18next';
import { HighlightedText } from '../../common/highlighted-text/HighlightedText';
import { useTranslation } from '../../../hooks/use-translations';

export type ExamplesCardProps = {
  image?: any;
  exampleNumber: number;
  examplesInfo: InfoForExample;
};

export const ExamplesCard = (props: ExamplesCardProps) => {
  const { t } = useTranslation();

  const textTranslated = (text1Key: string, text2: string, variant: 'blue' | 'green') => (
    <Trans
      i18nKey={text1Key}
      components={{
        highlightedText: <HighlightedText text={text2} highlightColor={variant} />,
      }}
      t={t}
    />
  );

  return (
    <div className={styles.cardWrapper}>
      <div className={styles.imageBanner}>
        {props.image && <props.image className={styles.image} />}
      </div>
      <div className={styles.infoWrapper}>
        <P1 className={styles.infoDescription}>
          {textTranslated(
            `examples.description${props.exampleNumber}.articles`,
            t(`common.weeks`, {
              count: props.examplesInfo.weeks,
            }),
            'green',
          )}
        </P1>
        <P1 className={styles.infoSummary} bold={true}>
          {textTranslated(
            `examples.description${props.exampleNumber}.savings`,
            props.examplesInfo.savings,
            'blue',
          )}
        </P1>
        <ArticlesList articles={props.examplesInfo.articles} />
      </div>
    </div>
  );
};
